"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SharedUrl = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _react = require("react");
var _hooks = require("../../../../hooks");
var _useTranslations = require("../../../../hooks/useTranslations");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SharedUrl = (param)=>{
    let { productList } = param;
    var _pplConfiguration_addThis;
    const { translations } = (0, _useTranslations.useTranslations)();
    const { data: pplConfiguration, isValidating: isLoading } = (0, _hooks.usePplConfigurationQuery)();
    const sharedUrl = pplConfiguration === null || pplConfiguration === void 0 ? void 0 : (_pplConfiguration_addThis = pplConfiguration.addThis) === null || _pplConfiguration_addThis === void 0 ? void 0 : _pplConfiguration_addThis.sharedUrl;
    const { palette } = (0, _mui.useTheme)();
    const copyLinkButtonInputButtonGradientColors = (0, _react.useMemo)(()=>({
            color3: palette.grey[100]
        }), [
        palette.grey
    ]);
    if (isLoading) {
        return null;
    }
    if ((productList === null || productList === void 0 ? void 0 : productList.productListId) && sharedUrl) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
            hasCopyButton: true,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                    textAlign: "left",
                    children: translations.sharingLinkButtonDescription
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CopyLinkInputButton, {
                    link: sharedUrl.replace('{personallist}', productList.productListId),
                    buttonText: translations.copyToClipboardBtn,
                    copiedText: translations.copyToClipboardTooltip,
                    backgroundGradientColors: copyLinkButtonInputButtonGradientColors
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
            fontWeight: "bold",
            children: translations.linkHere
        })
    });
};
exports.SharedUrl = SharedUrl;
